<template>
  <StepLayout pageId="page-3" title="Your Details" contentId="customerDetails-mod">
    <a-form-model id="reservationForm" ref="reservationForm" :model="infoForm" :rules="rules">
      <div class="formCol">
        <a-form-model-item prop="firstName">
          <div class="input-group input-with-icon">
            <img src="/static/images/avatar_icon.svg" class="input-icon" alt="" />
            <a-input class="form-control input-with-padding" placeholder="First Name" v-model="infoForm.firstName" />
          </div>
        </a-form-model-item>
      </div>
      <div class="formCol">
        <a-form-model-item prop="surname">
          <div class="input-group input-with-icon">
            <img src="/static/images/avatar_icon.svg" class="input-icon" alt="" />
            <a-input class="form-control input-with-padding" placeholder="Surname" v-model="infoForm.surname" />
          </div>
        </a-form-model-item>
      </div>
      <div class="formCol">
        <a-form-model-item prop="phone">
          <div class="phoneNumberCol">
            <div class="dropdown" id="mobile_areaCode">
              <a-select
                show-search
                optionLabelProp="label"
                dropdownClassName="area-code-dropdown"
                class="form-control custom-a-select area-code-select"
                :value="`${country}|${areaCode}`"
                :filter-option="filterAreaCode"
                @change="onAreaCodeChange"
              >
                <a-select-option v-for="(item, index) in areaCodes" :key="index" :value="`${item.country}|${item.code}`" :label="`${item.country} ${item.code}`">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </div>
            <input v-model="areaCode" type="hidden" id="area_code" name="area_code" />
            <div class="input-group input-with-icon">
              <img src="/static/images/phone_icon.svg" class="input-icon" alt="" />
              <a-input class="form-control input-with-padding" placeholder="Phone Number" v-model="infoForm.phone" type="tel" @change="handlePhoneInput" />
            </div>
          </div>
        </a-form-model-item>
      </div>
      <div class="formCol">
        <a-form-model-item prop="email">
          <div class="input-group input-with-icon">
            <img src="/static/images/email_icon.svg" class="input-icon" alt="" />
            <a-input class="form-control input-with-padding" placeholder="Email" v-model="infoForm.email" type="email" />
          </div>
        </a-form-model-item>
      </div>
      <div class="formCol" v-if="Number(allergy_show) === 1">
        <label>Allergens</label>
        <div class="input-group">
          <a-input class="form-control" v-model="infoForm.allergy" id="allergy_data" />
          <a href="javascript:void(0)" @click="allergySelect" id="allergyEditLink" data-target="#modal-ajax" data-toggle="modal"></a>
        </div>
      </div>
      <div class="formCol">
        <a-form-model-item prop="remark">
          <div class="input-group">
            <a-textarea id="customerNoteTextarea" :rows="4" v-model="infoForm.remark"
              class="form-control customerNote"
              placeholder="If you have any special requests, leave a message here" />
          </div>
        </a-form-model-item>
      </div>
    </a-form-model>
  </StepLayout>
</template>

<script>
import StepLayout from "./StepLayout.vue";
import { areaCodes } from '@/utils/countryCode.js';

export default {
  name: "ReservationStep3",
  components: { StepLayout },
  props: {
    infoForm: Object,
    country: String,
    areaCode: String,
    allergy_show: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      areaCodes,
      rules: {
        firstName: [
          { required: true, message: 'The first name cannot be empty', trigger: 'blur' },
          { min: 2, message: 'Your first name must consist of at least 2 characters', trigger: 'blur' }
        ],
        surname: [
          { required: true, message: 'The last name cannot be empty', trigger: 'blur' },
          { min: 2, message: 'Your last name must consist of at least 2 characters', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: 'The mobile number cannot be empty', trigger: 'blur' },
          { min: 10, message: 'Your mobile number must be at least 11 characters long', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Email cannot be empty', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    validateForm(callback) {
      if (this.$refs.reservationForm) {
        this.$refs.reservationForm.validate(valid => {
          callback(valid);
        });
      } else {
        callback(false);
      }
    },
    allergySelect() { this.$emit("allergySelect"); },
    filterAreaCode(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    onAreaCodeChange(val) {
      const [country, code] = val.split('|');
      this.$emit("getAreaCode", code, country);
    },
    handlePhoneInput(e) {
      // 只保留数字
      this.infoForm.phone = e.target.value.replace(/[^\d]/g, '');
    }
  }
};
</script>

<style lang="scss" scoped>
.input-with-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #ccc;
  font-size: 18px;
  z-index: 10;
  pointer-events: none;
  width: 18px;
  height: 18px;
}

.input-with-padding {
  padding-left: 35px;
}

::v-deep input.form-control,
::v-deep select.form-control,
::v-deep textarea.form-control {
  padding-left: 35px;
  line-height: 1.5;
  border-radius: 8px !important;
  /* box-shadow: 2px 2px 2px rgba(5, 5, 5, 0.05); */
  border-color: #f6f6f6 !important;
  background-color: #f6f6f6 !important;
}

::v-deep input.form-control,
::v-deep select.form-control {
  height: 50px;
  line-height: 50px;
  padding-top: 0;
  padding-bottom: 0;
}

::v-deep textarea.form-control {
  padding-left: 15px !important;
  padding-top: 10px;
  padding-bottom: 10px;
  resize: vertical;
}

.phoneNumberCol {
  position: relative;
  display: grid;
  grid-template-columns: 110px calc(100% - 120px);
  grid-auto-flow: dense;
  grid-column-gap: 10px;
}

.phoneNumberCol .dropdown {
  height: 100%;
}

.phoneNumberCol .dropdown .btn {
  width: 100%;
  height: 50px;
  background-color: #f6f6f6 !important;
  border: 1px solid #f6f6f6;
  border-radius: 8px;
  text-align: left;
  padding: 0 12px;
  font-size: 14px;
  color: #495057;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* box-shadow: 2px 2px 5px rgba(5, 5, 5, 0.1), 2px 2px 2px rgba(5, 5, 5, 0.05); */
}

.phoneNumberCol .dropdown .btn::after {
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: auto;
  vertical-align: middle;
  border-top: 5px solid;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  opacity: 0.5;
}

.phoneNumberCol .dropdown .btn:hover,
.phoneNumberCol .dropdown .btn:focus {
  background-color: #fff;
  border-color: #d0d0d0;
  outline: 0;
}

</style>

<style>
/* 针对使用 a-select 的样式全局穿透覆盖，确保在组件内无缝展示 */
#customerDetails-mod .custom-a-select {
  width: 100%;
  height: 50px;
  border: none !important;
  background-color: transparent !important;
  padding-left: 0;
}

#customerDetails-mod .custom-a-select .ant-select-selection {
  height: 50px !important;
  padding-left: 10px !important; 
  border-radius: 8px !important;
  border-color: #f6f6f6 !important;
  background-color: #f6f6f6 !important;
  box-shadow: none !important;
}

#customerDetails-mod .custom-a-select .ant-select-selection__rendered {
  line-height: 48px !important;
}

#customerDetails-mod .custom-a-select .ant-select-arrow {
  right: 12px !important;
}

.area-code-dropdown .ant-select-dropdown-menu-item {
  min-height: 46px !important;
  padding: 10px 14px !important;
  font-size: 14px !important;
  line-height: 1.45 !important;
  display: flex;
  align-items: center;
}

/* Ant Design Form Error Overrides */
#reservationForm .ant-form-item {
  margin-bottom: 0 !important;
}

#reservationForm .has-error .ant-input,
#reservationForm .has-error .ant-input:focus {
  border-color: #f5222d !important;
  background-color: #fff1f0 !important;
}

#reservationForm .has-error .ant-form-explain {
  text-align: left;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/ReservationStep3.vue